export const ENTERPRISE_SECURITY_HEADING = 'Enterprise Security';

export const FORENSIC_WATERMARK_LABEL = 'Forensic watermark';

export const FORENSIC_WATERMARK_DESCRIPTION =
  'An "invisible digital fingerprint" that traces unauthorized distribution';

export const DRM_LABEL = 'DRM';

export const DRM_DESCRIPTION =
  'Digital Rights Management - controls the use of digital content';
